import "../../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import React from 'react';
import { useMicrosite } from '../../../../contexts/franchise/microsite-context';
const FranchiseLicenses = (): JSX.Element => {
  const microsite = useMicrosite();
  const {
    biohazardContractorLicense,
    cslbContractorLicense,
    commercialContractorLicense,
    electricalContractorLicense,
    generalContractorLicense,
    moldRemediationContractorLicense,
    plumbingContractorLicense,
    residentialContractorLicense
  } = microsite?.franchise?.licenses || {};
  const licenseTexts = {
    'Biohazard Cleanup': biohazardContractorLicense,
    'CSLB (California)': cslbContractorLicense,
    Commercial: commercialContractorLicense,
    'Electrical License': electricalContractorLicense,
    'General Contractor License': generalContractorLicense,
    'Mold Remediation': moldRemediationContractorLicense,
    Plumbing: plumbingContractorLicense,
    Residential: residentialContractorLicense
  };
  return <div>
            {Object.entries(licenseTexts).map(([key, val]) => {
      if (val && typeof val !== 'boolean') {
        return <div key={key} className="licenses__div-3cal5d">
                            <strong>
                                {key}
                                :
                            </strong>
                            {' '}
                            {val}
                        </div>;
      }
      if (val && typeof val === 'boolean') {
        return <div key={key} className="licenses__div-2zk24n">
                            <strong>{key}</strong>
                        </div>;
      }
      return null;
    })}
        </div>;
};
export default FranchiseLicenses;